import * as React from "react"

import { translations, type LanguageCode } from "@/translations/translations"
import type { AuthUser } from "@/types/auth.types"

export type AppUser = AuthUser

export type AppContextValue = {
  theme: "dark" | "light"
  toggleTheme: () => void
  language: LanguageCode
  setLanguage: (lang: LanguageCode) => void
  t: (typeof translations)[LanguageCode]
  user: AppUser | null
  setUser: (user: AppUser | null) => void
  isAuthenticated: boolean
  hasAcceptedPolicy: boolean
  acceptPolicy: () => void
}

export const AppContext = React.createContext<AppContextValue | undefined>(
  undefined
)
